module.exports = __webpack_public_path__ + "img/20220317184239.f9af5938.png";